import { lazy } from 'react';

const PreSaleWorksSectionLazy = lazy(() => import('../PreSaleWorksSection'));

export default PreSaleWorksSectionLazy;
